import ApiRest from "@/api/api-rest";
import {
  CARBON_BLACK_LOAD_SYSTEM_PREF,
  CARBON_BLACK_SYSTEM_ENABLE,
  CARBON_BLACK_SYSTEM_DISABLE
} from "./system-pref.type";

// prettier-ignore
const state = {  
  carbonBlackSystemPrefEnabled: false,
  carbonBlackEnabled: false
}

const getters = {
  carbonBlackSystemPrefEnabled: state => state.carbonBlackSystemPrefEnabled,
  carbonBlackEnabled: state => state.carbonBlackEnabled
};

const mutations = {
  [CARBON_BLACK_LOAD_SYSTEM_PREF]: (state, data) => {
    state.carbonBlackEnabled = data.enabled;
    state.carbonBlackSystemPrefEnabled = data.id == null ? false : true;
  },
  [CARBON_BLACK_SYSTEM_ENABLE]: (state, value) => {
    state.carbonBlackEnabled = value;
  },
  [CARBON_BLACK_SYSTEM_DISABLE]: (state, value) => {
    state.carbonBlackEnabled = value;
  }
};

const actions = {
  [CARBON_BLACK_LOAD_SYSTEM_PREF](context) {
    ApiRest()
      .get("/features/enabled/carbonblack")
      .then(({ data }) => {
        context.commit(CARBON_BLACK_LOAD_SYSTEM_PREF, data);
      });
  },
  [CARBON_BLACK_SYSTEM_ENABLE](context) {
    ApiRest()
      .post("/features/enabled", {
        feature: "carbonblack",
        enabled: true
      })
      .then(({ data }) => {
        context.commit(CARBON_BLACK_SYSTEM_ENABLE, data.enabled);
      });
  },
  [CARBON_BLACK_SYSTEM_DISABLE](context) {
    ApiRest()
      .post("/features/enabled", {
        feature: "carbonblack",
        enabled: false
      })
      .then(({ data }) => {
        context.commit(CARBON_BLACK_SYSTEM_DISABLE, data.enabled);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/system_pref/system-pref.module.js